import { apiClient } from '../lib/apiClient';

const PLACEHOLDER_IMAGE = 'https://via.placeholder.com/200x200?text=Product';

const slugify = (value) => {
  if (!value) return '';
  return value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const normalizeArrayResponse = (response) => {
  if (!response) return [];
  const { data } = response;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.result)) return data.result;
  return [];
};

const parseNumber = (value, fallback = 0) => {
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};

const mapCartItem = (item) => {
  if (!item) return null;
  const productId = item.productId ?? item.product_id ?? item.productCode ?? item.id ?? null;
  const cartId = item.cartId ?? item.cart_id ?? `${productId ?? ''}-${item.variantId ?? ''}`;
  const name = item.productName ?? item.name ?? 'Product';
  const price = parseNumber(item.productPrice ?? item.price, 0);
  const quantity = parseNumber(item.quantity ?? item.qty ?? 0, 0);
  const total =
    parseNumber(item.totalPrice ?? item.total, price * quantity);

  const image =
    item.productImg ??
    item.image ??
    item.thumbnail ??
    PLACEHOLDER_IMAGE;

  const slug =
    item.productSlug ??
    item.slug ??
    slugify(`${productId ?? cartId}-${name}`);

  return {
    cartId,
    id: productId ?? cartId,
    sku: item.productSku ?? item.sku ?? productId ?? cartId,
    name,
    slug,
    price,
    quantity,
    totalPrice: total,
    image,
    raw: item,
  };
};

export const fetchCart = async () => {
  const response = await apiClient.get('/usermgmt/getAllCart');
  return normalizeArrayResponse(response).map(mapCartItem).filter(Boolean);
};

export const addCartItem = async ({ productId, productPrice, quantity }) => {
  return apiClient.post('/usermgmt/addCart', { productId, productPrice, quantity });
};

export const reduceCartItem = async ({ productId, productPrice, quantity }) => {
  return apiClient.put('/usermgmt/reduceCart', { productId, productPrice, quantity });
};

export const deleteCartItem = async (cartId) => {
  if (!cartId) {
    throw new Error('cartId is required to delete cart item.');
  }
  return apiClient.delete(`/usermgmt/cart/${cartId}`);
};

export const clearRemoteCart = async (cartItems = []) => {
  await Promise.all(
    cartItems
      .map((item) => item.cartId)
      .filter(Boolean)
      .map((cartId) =>
        apiClient
          .delete(`/usermgmt/cart/${cartId}`)
          .catch(() => null),
      ),
  );
};









